const EMOJIS = {
  CHECK_MARK: "✔️",
  CROSS_MARK: "❌",
  EXCLAMATION_MARK: "❗",
  PLAY_BUTTON: "▶️",
  HOURGLASS_NOT_DONE: "⏳",
};

export default EMOJIS;
